import { EventsState } from '@he-novation/config/types/event.types';
import { pick, pipe } from 'lodash/fp';
import { stateSelector as contentSelector } from '../../content/contentSelectors';
import { EVENTS } from './eventsActions';

import { ReduxState } from '$redux/store';

export const stateSelector: (state: ReduxState) => EventsState = pipe(
    contentSelector,
    (state) => state[EVENTS]
);

export const eventsSelector = pipe(
    stateSelector,
    pick(['events', 'isLoading', 'isUpdating', 'dateRangeUpdating'])
);

export const eventSelector = (eventUuid: string) =>
    pipe(stateSelector, ({ events }) => events.find((e) => e.uuid === eventUuid));
